var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush } from "../shared/utils";
var dataToDataLayer = function (e, specificEventData) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var dlData = normalizeObject(__assign(__assign(__assign({}, eventData), { event_category: "streamlined_checkout" }), specificEventData));
    dataLayerPush(dlData);
};
var photoUploadClick = function (e) {
    dataToDataLayer(e, {
        event: "chosen_photo_click",
        event_action: (e === null || e === void 0 ? void 0 : e.detail["chosen_photo_click"]) || "chosen_photo_click",
        event_category: "photo_mod_chosen",
        event_label: e === null || e === void 0 ? void 0 : e.detail["eventLabel"],
    });
};
var photoModError = function (e) {
    dataToDataLayer(e, {
        event: "error_view",
        event_action: (e === null || e === void 0 ? void 0 : e.detail["eventAction"]) || "reject",
        event_category: "chosen_error",
        event_label: e === null || e === void 0 ? void 0 : e.detail["eventLabel"],
        error_message: e === null || e === void 0 ? void 0 : e.detail["errorMessage"],
        error_type: "photo_mod_chosen_photo",
        event_errors: 1,
        non_interaction: true,
        total_errors: 1,
    });
};
export { photoUploadClick, photoModError };
